import { BAU_FILTER, BAU_REPORTS, BAU_REPORTS_EXPORT, PROVIDER_FILTER, PROVIDER_REPORTS, PROVIDER_REPORTS_EXPORT } from "apiConfig/qcreports";
import { getData, postData } from "services/basicApiService";

export const getPoviderList = (pagenumber, pagesize, search, data, header) => {
  return async () => {
   
    const response = await postData(
      PROVIDER_REPORTS +
        `?PageNumber=${pagenumber}&PageSize=${pagesize}&Search=${search}`,
      data,
      {
        "X-Project-ID": header,
      }
    ).catch((error) => {
      throw error;
    });
    if (response) {
      return response;
    }
  };
};
export const getPoviderListExport = (search, data, header) => {
  return async () => {
   
    const response = await postData(
      PROVIDER_REPORTS_EXPORT + `?&Search=${search}`,
      data,
      {
        "X-Project-ID": header,
      }
    ).catch((error) => {
      throw error;
    });
    if (response) {
      return response;
    }
  };
};
export const getBAUList = (pagenumber, pagesize, search, data, header) => {
  return async () => {
   
    const response = await postData(
     BAU_REPORTS +
        `?PageNumber=${pagenumber}&PageSize=${pagesize}&Search=${search}`,
      data,
      {
        "X-Project-ID": header,
      }
    ).catch((error) => {
      throw error;
    });
    if (response) {
      return response;
    }
  };
};
export const getBAUListExport = (search, data, header) => {
  return async () => {
   
    const response = await postData(
      BAU_REPORTS_EXPORT + `?&Search=${search}`,
      data,
      {
        "X-Project-ID": header,
      }
    ).catch((error) => {
      throw error;
    });
    if (response) {
      return response;
    }
  };
};
export const getProviderFilters = (header) => {
  return async () => {
   
    const response = await getData(PROVIDER_FILTER, {
      headers: {
        "X-Project-ID": header,
      },
    }).catch((error) => {
      throw error;
    });
    if (response) {
      return response;
    }
  };
}
export const getBauFilters = (header) => {
  return async () => {
   
    const response = await getData(BAU_FILTER, {
      headers: {
        "X-Project-ID": header,
      },
    }).catch((error) => {
      throw error;
    });
    if (response) {
      return response;
    }
  };
}